import {Component} from '@angular/core';
import {AppAuthService} from './auth/app-auth.service';
import {gitVersion} from '../version';
import {MatDividerModule} from '@angular/material/divider';
import {MatMenuModule} from '@angular/material/menu';
import {CommonModule} from '@angular/common';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatToolbarModule} from '@angular/material/toolbar';

@Component({
  selector: 'main-nav',
  templateUrl: 'main-nav.component.html',
  styleUrls: ['main-nav.component.scss'],
  imports: [
    CommonModule, MatToolbarModule, MatButtonModule, RouterLink, RouterLinkActive, MatMenuModule, MatDividerModule
  ]
})
export class MainNavComponent {
  public version = gitVersion;

  constructor(public authService: AppAuthService) {
  }
}
